import { Role } from '@/models/auth';
import FolderIcon from '@mui/icons-material/Folder';
import SafetyCheckIcon from '@mui/icons-material/SafetyCheck';
import HomeIcon from '@mui/icons-material/Home';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PaidIcon from '@mui/icons-material/Paid';

export const adPartnerRoutes = [
  {
    labelKey: 'menu.dashboard',
    to: '/client',
    Icon: HomeIcon,
  },
  {
    labelKey: 'ads.create_ad_text',
    to: '/client/create/ad',
    Icon: AddCircleIcon,
  },
  {
    labelKey: 'label.campaigns',
    to: '/client/campaigns',
    Icon: FolderIcon,
  },
  {
    labelKey: 'label.in_review',
    to: '/client/review/ads',
    Icon: SafetyCheckIcon,
  },
];

export const taxiPartnerRoutes = [
  {
    labelKey: 'label.dashboard',
    to: '/partner',
    Icon: DashboardIcon,
  },
  {
    labelKey: 'label.payments',
    to: '/partner/payments',
    Icon: PaidIcon,
  },
];

export const NAVIGATION_PATH = {
  [Role.AdPartner]: '/client',
  [Role.TaxiPartner]: '/partner',
};

export const routes = {
  [Role.AdPartner]: adPartnerRoutes,
  [Role.TaxiPartner]: taxiPartnerRoutes,
};
